






















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import { getStatusName, getStatusColor } from '@/services/jobService';
import moment from 'moment';
import * as util from "comunet-jobs-and-technician-repository-shared/util";

@Component({})
export default class JobStatusHistoryItem extends Vue {
  @Prop({ type: String }) public at!: string;
  @Prop({ type: Number }) public statusId!: number;
  @Prop({ type: String }) public comment!: string;
  @Prop({ type: Boolean }) public canDelete!: boolean;
  @Prop({ type: Boolean }) public loading!: boolean;
  @Prop({ type: Boolean }) public createMode!: boolean;
  @Prop({ type: String }) public errorMessage!: string;

  private atDateMenu: boolean = false;
  private atTimeMenu: boolean = false;
  private internalAt: string = this.at ? this.at : moment().format();
  private internalStatusId: number = this.statusId ? this.statusId : JobUserStatusEnum.START_CONTINUE_WORK;
  private internalComment: string = this.comment ? this.comment : "";

  get atDateDisplay(){
    return util.readableDate(this.internalAt);
  }

  get atDateValue(){
    return util.datePickerDate(this.internalAt);
  }

  get atTimeDisplay(){
    return moment(this.internalAt).format("HH:mm");
  }

  get atTimeValue(){
    return moment(this.internalAt).format("HH:mm");
  }

  get statusOptions(){
    return [
      JobUserStatusEnum.TRAVEL, 
      JobUserStatusEnum.START_CONTINUE_WORK, 
      JobUserStatusEnum.NONE_CHARGEABLE, 
      JobUserStatusEnum.BREAK, 
      JobUserStatusEnum.DAY_COMPLETE, 
      JobUserStatusEnum.FINISH_WORK
    ].map(x => {
      return {
        id: x,
        name: getStatusName(x),
        color: getStatusColor(x)
      };
    });
  }

  onAtDate(v: string){
    let value = moment(v);

    this.internalAt = moment(this.internalAt)
      .set('date', value.get('date'))
      .set('month', value.get('month'))
      .set('year', value.get('year'))
      .format();
  }

  onAtTime(v: string){
    let value = moment(v, 'HH:mm');

    this.internalAt = moment(this.internalAt)
      .set('hours', value.get('hours'))
      .set('minutes', value.get('minutes'))
      .format();
  }

  get canHaveComment(){
    return this.internalStatusId === JobUserStatusEnum.FINISH_WORK;
  }

  remove(){
    this.$emit('onDelete');
  }

  save(){
    this.$emit('onSave', {
      at: this.internalAt,
      statusId: this.internalStatusId,
      comment: this.internalComment
    })
  }
}

